import * as THREE from 'three';
import {
  CARD1Web,
} from '../../CoordUtils.js';

import {
  ModelLoader
} from '@/drawings3D/ModelLoader';

//这个类用来载入路牌所需要的各种贴图，使用canvas实现
export class CommonLoader extends ModelLoader {
  constructor(commonOption, sceneManager) {
    // console.log('2222111122222',commonOption)
    var modelInfo = {
        modelPath: commonOption.option.modelPath,
        name: commonOption.option.name,
        extraPartConfig:{
          option:commonOption
        }
      }
    super(sceneManager, modelInfo);
  }

  loadExtraParts(extraPart, loadedMesh) {
     loadedMesh.oInfo = extraPart.option.option.info;
  }

}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/modelDrawing/DirectModel/CommonLoader.js